jQuery(document).ready(function ($) {

    class ShareModal {
        embedWidth = 640;
        embedHeight = 360;

        init() {
            $("#linkText").val(this.getLink());
            $("#embedText").val(this.getEmbed());

            this.addListeners();
        }

        // copying functions modified from:
        // https://stackoverflow.com/a/30810322
        fallbackCopy(elem) {
            elem.focus();
            elem.select();
    
            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Fallback: Copying text command was ' + msg);
                return true
            } catch (err) {
                console.error('Fallback: Unable to copy', err);
                return false
            }
        }
    
        customCopy(button, textElem) {
            if (!navigator.clipboard) {
                let success = this.fallbackCopy(textElem);
                if (success) {
                    button.text("Copied!");
                    setTimeout(() => {
                        button.text("Copy");
                    }, 1400);
                }
            }
            navigator.clipboard.writeText(textElem.val()).then(function () {
                console.log('Async: Copying to clipboard was successful');
                button.text("Copied!");
                textElem.select()
                setTimeout(() => {
                    button.text("Copy");
                }, 1400);
    
            }, function (err) {
                console.error('Async: Could not copy text: ', err);
            });
        }
        
        getLink() {
            let i = document.location.href.lastIndexOf("/");
            return document.location.href.slice(0, i + 1)
        }
        
        getEmbed() {
            let src = this.getLink() + "?emb=1";
            return `<iframe id="pixelpad-embed" title="${document.title}" style="border: none;" src="${src}" width="${this.embedWidth}" height="${this.embedHeight}"></iframe>`;
        }

        changeEmbedDimensions(event) {
            let target = event.currentTarget;
            
            let value = parseInt(target.value);
            if (target.id === "embedWidth") {
                if (isNaN(value) || value < 1 || value > 10000) { // Invalid input goes to default
                    value = 640
                }

                this.embedWidth = value;
    
            } else if (target.id === "embedHeight") {
                if (isNaN(value)  || value < 1 || value > 10000) { // Invalid input goes to default
                    value = 360
                }

                this.embedHeight = value;
            }

            $("#embedText").val(this.getEmbed());
        }

        addListeners() {
            let _this = this;
            $("#shareModal .btn").on("mouseup", function () { this.blur() })

            let linkText = $("#copyLink").closest(".input-group").find("input:first");
            let copyLink = $("#copyLink");

            copyLink.on("click", function () {
                _this.customCopy(copyLink, linkText);
            });

            linkText.on("click", () => {
                linkText.select()
            })
            
            let embedText = $("#embedText");
            let copyEmbed = $("#copyEmbed");

            copyEmbed.on("click", function () {
                _this.customCopy(copyEmbed, embedText);
            });

            embedText.on("click", () => {
                embedText.select()
            })
            
            $("#embedWidth").on("input", function(e) {
                _this.changeEmbedDimensions(e);
            });
        
            $("#embedHeight").on("input", function(e) {
                _this.changeEmbedDimensions(e);
            });
        }
    }

    let shareModal = new ShareModal();
    shareModal.init();

});